module.exports = __webpack_public_path__ + "img/app-store.0218bf36.png";